import type { Metric, NavItem } from '../types'

export const candidate = {
  name: 'Adebayo S. Bello',
  shortName: 'Bello',
  initials: 'ASB',
  cycle: '2027',
  slogan: 'A Nigeria That Works. For Everyone.',
  eyebrow: 'Adebayo S. Bello for President',
  supporting:
    'A serious plan for jobs, security and power — built on thirty years of delivering results in public service and enterprise, across all six geopolitical zones.',
  portraitPrimary:
    'https://cdn.magicpatterns.com/uploads/mnZhzX2nqLH2XbADz2erb2/ASB_(9).png',
  portraitSigning:
    'https://cdn.magicpatterns.com/uploads/g3WiugGQPBDoopKz7uDstx/ASB_(8).png',
}

export const primaryNav: NavItem[] = [
  { label: 'Candidate', href: '/candidate' },
  { label: 'Vision', href: '/vision' },
  { label: 'Agenda', href: '/agenda' },
  { label: 'Track Record', href: '/track-record' },
  { label: 'News', href: '/news' },
  { label: 'Events', href: '/events' },
  { label: 'Join', href: '/join' },
  { label: 'Media', href: '/media' },
]

export const mobileExtraNav: NavItem[] = [
  { label: 'Facts & Answers', href: '/facts' },
  { label: 'Manifesto', href: '/manifesto' },
  { label: 'Contact', href: '/contact' },
]

export const languages = ['English', 'Hausa', 'Yorùbá', 'Igbo', 'Pidgin']

export const metrics: Metric[] = [
  { value: '36', label: 'States + FCT', note: 'Campaign structure in every state' },
  { value: '774', label: 'Local governments', note: 'Ward-level coordination' },
  { value: '412,000', label: 'Registered volunteers', note: 'Verified as of 12 August' },
  { value: '128', label: 'Campaign offices', note: 'Open and operational' },
]
